import React from 'react';
import { baseStyles } from '../styles';
import { CareMapprLayoutBasic } from '../../ai2/layout/Ai2Layout';
import { SignInForm } from '../components/SignInForm';

const SignIn: React.FC = () => {
  return (
    <CareMapprLayoutBasic>
      <div style={baseStyles.app}>
        <SignInForm />
      </div>
    </CareMapprLayoutBasic>
  );
};

export default SignIn;
